module.exports = __webpack_public_path__ + "static/media/CLOROSHOCK.02aea717.png";